import React from "react";
import "./Icons.scss";

const Icon = () => {
  return (
    <svg
      className="menu-icon-three-dots"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.25 22.92"
    >
      <g id="Graphicss">
        <circle className="cls-1" cx="12.52" cy="10" r="0.9" />
        <circle className="cls-1" cx="10.92" cy="12.58" r="0.9" />
        <circle className="cls-1" cx="14" cy="12.6" r="0.9" />
        <circle className="cls-2" cx="12.39" cy="11.42" r="8.98" />
      </g>
    </svg>
  );
};

export default Icon;
